import { green, magenta, yellow } from 'globals/colors';
import { CSSProperties } from 'react';

export const getBarColor = (idx?: number): string => {
  switch (idx) {
    case 0:
      return yellow.MAIN;
    case 1:
      return green.MAIN;
    case 2:
      return magenta.BRAND;
    default:
      return yellow.MAIN;
  }
};

export const getFsSingleBarGraphStyle = (): CSSProperties => ({
  flex: '1 1 0px',
});

export default {
  getBarColor,
};
